import { useState, useEffect } from "react";

export default function useResizeObserver(ref) {
  const [size, setSize] = useState({ width: 0, height: 0 });

  // useEffect (not useLayoutEffect) is intentional: using layout-effect here
  // causes both ResizeObservers (containerRef + metadataRef in Collection) to
  // fire synchronously in the same frame during dialog open, which exhausts the
  // browser's ResizeObserver notification budget and triggers the "loop
  // completed with undelivered notifications" error. Deferring to after-paint
  // breaks that cascade with no perceptible visual difference (both refs are
  // already gated — the VGrid won't render until both values are > 0 anyway).
  useEffect(() => {
    if (!ref.current) return;

    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const { width, height } = entry.contentRect;
        setSize({ width, height });
      }
    });

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [ref]);

  return size;
}
